import { COMMON_AMPLITUDE_CONFIG } from "@common-shared/config/amplitude.config.ts"
import type { IIndexable } from "@common-shared/types/general.types.ts"

import { HttpHelper as NirvanaHttpHelper } from "@front-shared/helpers/http.helper.ts"
import { ToastrHelper } from "@front-shared/helpers/toastr.helper.tsx"
import type { AvailableHttpMethod } from "@front-shared/types/general.ts"

import { GENERAL_CONFIG } from "../config/general.config"
import { AmplitudeHelper } from "./amplitude.helper"
import { AuthHelper } from "./auth.helper"

export class HttpHelper {
    /**
     * Send request to server
     */
    static async sendRequest(
        url: string,
        data: IIndexable = {},
        method: AvailableHttpMethod = "GET",
        headers: IIndexable = {},
        appendApiUrl: string | undefined = import.meta.env.VITE_API_URL,
        errorToastrTimeout = GENERAL_CONFIG.defaultToastrTimeout,
        ignoreToastrErrorCodes: number[] = [],
        abortSignal?: AbortSignal,
    ): Promise<any> {
        headers = Object.assign({}, headers)

        // Add Amplitude device ID to headers if available
        headers[COMMON_AMPLITUDE_CONFIG.amplitudeDeviceIdHeader] =
            AmplitudeHelper.getInstance()?.getDeviceId()

        if (await AuthHelper.isLoggedIn()) {
            const adminViewAsData = AuthHelper.getEagleEyeViewAsData()

            // Override what current user will see (practice and therapist data), aka God mode
            if (adminViewAsData) {
                headers[GENERAL_CONFIG.eagleEye.headers.userId] =
                    adminViewAsData.user?.id

                headers[GENERAL_CONFIG.eagleEye.headers.practiceId] =
                    adminViewAsData.practice?.id
            }
        }

        return await NirvanaHttpHelper.sendRequest(
            url,
            data,
            method,
            appendApiUrl,
            headers,
            await AuthHelper.getAccessToken(),
            errorToastrTimeout,
            [...ignoreToastrErrorCodes, 401],
            ToastrHelper.error,
            ToastrHelper.warning,
            () => {
                ToastrHelper.error(
                    "Auth token expired, please refresh the page and log in again to continue.",
                )

                AuthHelper.logout(null)
            },
            undefined,
            undefined,
            undefined,
            abortSignal,
        )
    }
}
